import Field, { helpId } from './Field';

export const InputControl = ({ id, error = '', describedBy, className = '', ...rest }) => (
  <div className={['field__control', className].filter(Boolean).join(' ')}>
    <input
      id={id}
      className="field__input"
      aria-invalid={error ? true : undefined}
      aria-describedby={describedBy}
      {...rest}
    />
  </div>
);

const Input = ({
  id,
  label,
  size = 'default',
  required = false,
  help = '',
  error = '',
  className = '',
  ...rest
}) => (
  <Field
    id={id}
    label={label}
    labelFor={id}
    size={size}
    required={required}
    help={help}
    error={error}
    className={className}
  >
    <InputControl
      id={id}
      error={error}
      describedBy={error || help ? helpId(id) : undefined}
      required={required}
      {...rest}
    />
  </Field>
);

export default Input;
